export class ConnectionStatistics {
    name = '';
    type = '';
    logo = '';
    shouldReauthorize = false;

    deserialize(data: any): this {
        this.name = data.name ?? '';
        this.type = data.type ?? '';
        this.logo = data.logo ?? '';
        this.shouldReauthorize = data.should_reauthorize ?? false;
        return this;
    }
}

class CompanyStatistics {
    numCompanies = 0;
    numPersonalTaxCompanies = 0;

    deserialize(data: any): this {
        this.numCompanies = data.num_companies ?? 0;
        this.numPersonalTaxCompanies = data.num_personal_tax_companies ?? 0;
        return this;
    }
}

class MemberStatistics {
    roleName = '';
    number = 0;

    deserialize(data: any): this {
        this.roleName = data.role_name ?? '';
        this.number = data.number ?? 0;
        return this;
    }
}

class InvitationStatistics {
    numInvitations = 0;
    oldestInvitationDate?: Date;

    deserialize(data: any): this {
        this.numInvitations = data.num_invitations ?? 0;
        this.oldestInvitationDate = data.oldest_invitation_date != null ? new Date(data.oldest_invitation_date) : undefined;
        return this;
    }
}

class ActivityStatistics {
    date = new Date();
    calls = 0;

    deserialize(data: any): this {
        this.date = data.date != null ? new Date(data.date) : this.date;
        this.calls = data.calls ?? 0;
        return this;
    }
}

export class OrganisationStatistics {
    connections = [] as ConnectionStatistics[];
    companies = new CompanyStatistics();
    members = [] as MemberStatistics[];
    invitations = new InvitationStatistics();
    activity = [] as ActivityStatistics[];
    numActiveUsers = 0;

    deserialize(data: any): this {
        this.connections = data.connections?.map((conn: any) => new ConnectionStatistics().deserialize(conn)) ?? [];
        this.companies = data.companies != null ? new CompanyStatistics().deserialize(data.companies) : this.companies;
        this.members = data.members?.map((member: any) => new MemberStatistics().deserialize(member)) ?? [];
        this.invitations = data.invitations != null ? new InvitationStatistics().deserialize(data.invitations) : this.invitations;
        this.activity = data.activity?.map((activity: any) => new ActivityStatistics().deserialize(activity)) ?? [];
        this.numActiveUsers = data.num_active_users ?? 0;
        return this;
    }
}
